(function () {
  'use strict';

  var MODAL_ID = 'mt-bij-modal';

  function euro(cents) {
    return '\u20AC\u00a0' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function checkedRows() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-mt-row].is-checked')
    );
  }

  function updateSummary() {
    var summary = document.querySelector('[data-mt-summary]');
    if (!summary) return;
    var rows = checkedRows();
    if (!rows.length) { summary.hidden = true; summary.innerHTML = ''; return; }
    var total = 0, names = [];
    rows.forEach(function (row) {
      total += parseInt(row.dataset.price, 10) || 0;
      var n = row.querySelector('.mt-bij__name');
      names.push(n ? n.textContent.trim() : '');
    });
    summary.hidden = false;
    summary.innerHTML = '\uD83D\uDED2 ' + names.join(', ') +
      ' &mdash; <strong>' + euro(total) + '</strong> wordt meebesteld';
  }

  function toggleRow(row) {
    if (row.classList.contains('is-unavailable')) return;
    var on = row.classList.toggle('is-checked');
    row.setAttribute('aria-checked', on ? 'true' : 'false');
    updateSummary();
  }

  function bindRows() {
    document.querySelectorAll('[data-mt-row]').forEach(function (row) {
      if (row.dataset.mtBound) return;
      row.dataset.mtBound = '1';
      if (row.classList.contains('is-unavailable')) return;

      row.addEventListener('click', function (e) {
        if (e.target.closest('[data-mt-info]')) return; // thumb/info -> modal
        toggleRow(row);
      });
      row.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleRow(row); }
      });
    });
  }

  /* ---------- info-modal ---------- */
  function ensureModal() {
    var modal = document.getElementById(MODAL_ID);
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.className = 'mt-bij-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<div class="mt-bij-modal__card">' +
        '<button class="mt-bij-modal__close" type="button" aria-label="Sluiten">&times;</button>' +
        '<img class="mt-bij-modal__img" src="" alt="">' +
        '<div class="mt-bij-modal__body">' +
          '<p class="mt-bij-modal__name"></p>' +
          '<p class="mt-bij-modal__price"></p>' +
          '<p class="mt-bij-modal__desc"></p>' +
          '<a class="mt-bij-modal__link" href="#" target="_blank" rel="noopener">Bekijk volledige productpagina \u2192</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);
    function close() { modal.classList.remove('is-open'); }
    modal.querySelector('.mt-bij-modal__close').addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    return modal;
  }

  function openModal(el) {
    var modal = ensureModal();
    var img = modal.querySelector('.mt-bij-modal__img');
    var src = el.getAttribute('data-img');
    if (src) { img.src = src; img.alt = el.getAttribute('data-name') || ''; img.style.display = 'block'; }
    else { img.style.display = 'none'; }
    modal.querySelector('.mt-bij-modal__name').textContent = el.getAttribute('data-name') || '';
    modal.querySelector('.mt-bij-modal__price').textContent = el.getAttribute('data-price') || '';
    modal.querySelector('.mt-bij-modal__desc').textContent = el.getAttribute('data-desc') || '';
    var link = modal.querySelector('.mt-bij-modal__link');
    var handle = el.getAttribute('data-handle');
    if (handle) { link.href = '/products/' + handle; link.style.display = 'inline-block'; }
    else { link.style.display = 'none'; }
    modal.classList.add('is-open');
  }

  document.addEventListener('click', function (e) {
    var info = e.target.closest('[data-mt-info]');
    if (info) { e.preventDefault(); e.stopPropagation(); openModal(info); }
  });
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && document.activeElement &&
        document.activeElement.matches('.mt-bij__thumb[data-mt-info]')) {
      e.preventDefault(); openModal(document.activeElement);
    }
  });

  /* ---------- winkelwagen ---------- */
  function sectionsToRender() {
    return [
      { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-count' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-amount' }
    ];
  }
  function sectionInnerHTML(html, selector) {
    var node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return node ? node.innerHTML : '';
  }
  function renderCart(sections) {
    sectionsToRender().forEach(function (s) {
      var container = document.getElementById(s.id);
      if (!container || !sections[s.section]) return;
      var target = container.querySelector(s.selector) || container;
      target.innerHTML = sectionInnerHTML(sections[s.section], s.selector);
    });
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
    else document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function bindForm() {
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form || form.dataset.mtBijBound) return;
    form.dataset.mtBijBound = '1';

    form.addEventListener('submit', function (e) {
      var rows = checkedRows();
      if (!rows.length) return; // niets aangevinkt -> laat thema het afhandelen

      e.preventDefault();
      e.stopImmediatePropagation();

      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      var mainId = idInput ? parseInt(idInput.value, 10) : null;
      if (!mainId) return;
      var mainQty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      var items = [{ id: mainId, quantity: mainQty }];
      rows.forEach(function (row) {
        items.push({ id: parseInt(row.dataset.variantId, 10), quantity: 1 });
      });

      var buttons = document.querySelectorAll('.single-add-to-cart-button');
      buttons.forEach(function (b) { b.classList.add('loading'); b.setAttribute('aria-disabled', 'true'); });

      fetch((window.theme && theme.routes ? theme.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: sectionsToRender().map(function (s) { return s.section; }),
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res && res.sections) renderCart(res.sections);
          else document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:item-added', {
            bubbles: true, detail: { product: res.items ? res.items[0] : res }
          }));
        })
        .catch(function (err) { console.error('[mt-bijproducten]', err); })
        .finally(function () {
          buttons.forEach(function (b) { b.classList.remove('loading'); b.removeAttribute('aria-disabled'); });
        });
    }, true); // capture-fase: vóór de themahandler
  }

  function init() {
    if (!document.querySelector('[data-mt-bij]')) return;
    bindRows();
    bindForm();
    updateSummary();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();